export enum SidenavigationLinkType {
  Region="Region",
  Municipality="Municipality",
  NominationDistrict="NominationDistrict",
  PollingDistrict="PollingDistrict"
}